import { useEffect, useState } from "react";
import axios from "axios";

export default function UpdateWebsite() {

const token = localStorage.getItem("token"); 
  //search 
  const [search, setSearch] = useState("");

  //other
  const [websites, setWebsites] = useState([]);
  const [editingWebsite, setEditingWebsite] = useState(null);
  const [msg, setMsg] = useState("");

  const loadWebsites = () => {
    axios
      .get(`/api/websites` , {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => setWebsites(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    loadWebsites();
  }, []);

  const handleChange = (e) => {
    setEditingWebsite({
      ...editingWebsite,
      [e.target.name]: e.target.value
    });
  };

  const saveUpdate = (e) => {
    e.preventDefault();

    axios.put(
      `/api/websites/${editingWebsite.sajtID}`,
      editingWebsite
    , {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(() => {
      setMsg("Sajt ažuriran ✅");
      setEditingWebsite(null);
      loadWebsites();
    })
    .catch(() => setMsg("Greška pri update ❌"));
  };


// Filtrirana lista po search inputu
    const s = search.toLowerCase();

    const filteredWebsites = (websites || []).filter(w =>
      (w?.naziv || "").toLowerCase().includes(s) ||
      String(w?.sajtID || "").includes(search) ||
      String(w?.ref_num || "").includes(search) ||
      (w?.httpadresa || "").toLowerCase().includes(s) ||
      (w?.ime || "").toLowerCase().includes(s) ||
      (w?.email || "").toLowerCase().includes(s)
    );

  return (
    <div className="card bg-dark text-white p-4">
      <h4>Website update</h4>

      {/* LOKALNI SEARCH */}
      <input
        type="text"
        className="form-control mb-3 w-25"
        placeholder="Search by ID or data..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {msg && <p>{msg}</p>}

      {/* EDIT FORMA */}
      {editingWebsite && (
        <form onSubmit={saveUpdate} className="mb-4">

          <label for="ime">Naziv</label>
          <input className="form-control mb-2"
            name="naziv"
            value={editingWebsite.naziv}
            onChange={handleChange}
          />

          <label for="ime">HTTP</label>
          <input className="form-control mb-2"
            name="httpadresa"
            value={editingWebsite.httpadresa}
            onChange={handleChange}  
          />

          <label for="ref_num">Reference</label>
          <input className="form-control mb-2"
            name="ref_num"
            value={editingWebsite.ref_num}
            onChange={handleChange}
          />

          <label for="sajt_akreditacija">Sajt Login</label>
          <input className="form-control mb-2"
            name="sajt_akreditacija"
            value={editingWebsite.sajt_akreditacija}
            onChange={handleChange}
          />

          <label for="ime">CPanel Login</label>
          <input className="form-control mb-2"
            name="cpanel_akreditacija"
            value={editingWebsite.cpanel_akreditacija}
            onChange={handleChange}
          />

          <label for="ime">domen_expire</label>
          <input className="form-control mb-2"
            type="date"
            name="domen_expire"
            value={editingWebsite.domen_expire}
            onChange={handleChange}
          />

          <label for="ime">hosting_expire</label>
          <input className="form-control mb-2"
            type="date"
            name="hosting_expire"
            value={editingWebsite.hosting_expire}
            onChange={handleChange}
          />   

          <label for="ime">odrzavanje</label>
          <input className="form-control mb-2"
            name="odrzavanje"
            value={editingWebsite.odrzavanje}
            onChange={handleChange}
          />    

          <label for="ime">Klijent - ID</label>
          <input className="form-control mb-2"
            name="klijentID"
            value={editingWebsite.klijentID}
            onChange={handleChange}
          />   

           

          <button className="btn btn-success w-100">
            Sačuvaj izmene
          </button>

        </form>
      )}
        
      {/* TABELA */}
      <table className="table table-dark">
        <thead>
          <tr>
            <th>Naziv</th>
            <th>HTTP</th>
            <th>Reference</th>
            <th>Sajt Login</th>            
            <th>CPanel Login</th>
            <th>domen_expire</th>
            <th>hosting expire</th>            
            <th>odrzavanje</th>
            <th>Klijent</th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {filteredWebsites.map(w => (
            <tr key={w.sajtID}>
              <td>{w.naziv}</td>
              <td>{w.httpadresa}</td>
              <td>{w.ref_num}</td>
              <td>{w.sajt_akreditacija}</td>
              <td>{w.cpanel_akreditacija}</td>
              <td>{w.domen_expire}</td>
              <td>{w.hosting_expire}</td>
              <td>{w.odrzavanje}</td>
              <td>{w.klijentID}</td>
              <td>
                <button
                  className="btn btn-warning btn-sm"
                  onClick={() => setEditingWebsite(w)}
                >
                  Edit
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
}